import { createBrowserHistory } from 'history';
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';

// domain stores
import { numberLockSessionStore } from '~/common/stores/domain/numberLockSession.js';
import { annualUpgradeStore } from '~/common/stores/domain/annualUpgrade';
import { cmsStore } from '~/common/stores/domain/cms';
import { autoCompleteStore } from '~/common/stores/domain/addressAutocomplete';
import { promoCodeStore } from '~/common/stores/domain/promoCode.js';
import { userLocationStore } from '~/common/stores/domain/userLocation.js';
import { lockNumberStore } from '~/common/stores/domain/lockNumber.js';
import { customTollFreeNumbersStore } from '~/common/stores/domain/customTollFreeNumbers.js';
import { localNumbersStore } from '~/common/stores/domain/localNumbers.js';
import { offerSuiteStore } from '~/common/stores/domain/offerSuite.js';
import { requestLocalNumberStore } from '~/common/stores/domain/requestLocalNumber.js';
import { requestSMSStore } from '~/common/stores/domain/requestSMS.js';
import { tollFreeNumbersStore } from '~/common/stores/domain/tollFreeNumbers.js';
import { pendingStore } from '~/common/stores/domain/pending.js';
import { suggestedCitiesStore } from '~/common/stores/domain/suggestedCities.js';
import { emailCaptureStore } from '~/common/stores/domain/emailCapture.js';
import { flexFrameStore } from '~/common/stores/domain/flexFrame.js';
import { trialSignupStore } from '~/common/stores/domain/trialSignup.js';
import { convertToPaidStore } from '~/common/stores/domain/convertToPaid.js';
import { transferNumberStore } from '~/common/stores/domain/transferNumber.js';
import { rubyStore } from '~/common/stores/domain/rubyStore.js';
import { reCaptchaStore } from '~/common/stores/domain/recaptcha';

// ui stores
import { numberPickerStore } from '~/common/stores/ui/numberPicker.js';
import { modalStore } from '~/common/stores/ui/modal.js';
import { directPurchaseStore } from '~/common/stores/ui/directPurchase.js';
import { plansStore } from '~/common/stores/ui/plans.js';
import { tollFreeStore } from '~/common/stores/ui/tollFree.js';
import { progressStore } from '~/common/stores/ui/progress.js';
import { formsStore } from '~/common/stores/ui/forms.js';
import { sharedFormUtilsStore } from '~/common/stores/ui/sharedFormUtils.js';
import { accountInfoStore } from '~/common/stores/ui/accountInfo.js';
import { billingInfoStore } from '~/common/stores/ui/billingInfo.js';
import { responsiveStore } from '~/common/stores/ui/responsive.js';
import { loginStore } from '~/common/stores/ui/loginStore.js';
import { productTrackingStore } from '~/common/stores/ui/productTracking';

const browserHistory = createBrowserHistory();
const routingStore = new RouterStore();

export const history = syncHistoryWithStore(browserHistory, routingStore);

// combine stores
const stores = {
    modalStore,
    numberLockSessionStore,
    cmsStore,
    promoCodeStore,
    userLocationStore,
    customTollFreeNumbersStore,
    localNumbersStore,
    offerSuiteStore,
    pendingStore,
    plansStore,
    requestLocalNumberStore,
    requestSMSStore,
    tollFreeNumbersStore,
    transferNumberStore,
    suggestedCitiesStore,
    tollFreeStore,
    lockNumberStore,
    progressStore,
    emailCaptureStore,
    flexFrameStore,
    trialSignupStore,
    formsStore,
    sharedFormUtilsStore,
    convertToPaidStore,
    accountInfoStore,
    billingInfoStore,
    directPurchaseStore,
    responsiveStore,
    autoCompleteStore,
    numberPickerStore,
    rubyStore,
    loginStore,
    annualUpgradeStore,
    productTrackingStore,
    reCaptchaStore
};

// export stores bootstrap
export function bootstrapStores() {
    offerSuiteStore.bootstrapStore();
    cmsStore.bootstrapStore();
    promoCodeStore.bootstrapStore();
    requestLocalNumberStore.bootstrapStore();
    localNumbersStore.bootstrapStore();
    tollFreeNumbersStore.bootstrapStore();
    customTollFreeNumbersStore.bootstrapStore();
    emailCaptureStore.bootstrapStore();
    flexFrameStore.bootstrapStore();
    transferNumberStore.bootstrapStore();
    convertToPaidStore.bootstrapStore();
    reCaptchaStore.bootstrapStore();
}

// export stores to use with provider
export default stores;

